<template>
	<div class="filters-box">
		<div class="filters-box-row" :style="collapse ? 'height: 42px' : ''">
			<div class="data-picker-box">
				<!-- <span>时间周期：</span> -->
				<el-date-picker
					v-model="dateValue"
					size="small"
					:clearable="false"
					type="datetimerange"
					align="right"
					popper-class="filter-time-popper"
					unlink-panels
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:default-time="['00:00:00', '23:59:59']"
					format='yyyy-MM-dd HH:mm'
					value-format='yyyy-MM-dd HH:mm'>
				</el-date-picker>
			</div>
			<div class="order-name-box">
				<span>客户名称：</span>
				<el-input v-model="customerName" placeholder="请输入客户名称" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-type-box">
				<span>客户类别：</span>
				<el-select v-model="customercategoryid" filterable multiple collapse-tags class="order-type-select" size='small'>
					<!-- <el-option value="0" label="全部"></el-option> -->
					<el-option v-for="item in customList" :value="item.ccid" :label="item.ccname" :key="item.ccid"></el-option>
				</el-select>
			</div>
		</div>
		<!-- <div class="collapse-box">
			<el-button size="small" type="text" class="btn" style="color:var(--fx-primary-color);margin-left:10px" @click="handleCollapse">
				{{ collapse ? '展开' : '收起' }}
				<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:var(--fx-primary-color);"/>
			</el-button>
		</div> -->
	</div>
</template>
<script>
export default {
	name: 'FiltersBox',
	props: {
		customSaleNewSearchParams: {
			type: Object,
			default: () => {}
		}
	},
	data () {
		return {
			options: [
				{ value: '全部' },
				{ value: '订单' },
				{ value: '退单' }
			],
			ordertype: '全部',
			ordernumber: '',
			pname: '',
			dateValue: [],
			customerName: '',
			customerCode: '',
			pcode: '',
			bigcategoryview: null,
			bigcategoryid: '0',
			smallcategoryid: '0',
			liquidateflag: '-1',
			bc: [],
			sc: [],
			orderstatus: [],
			customercategoryid: [],
			customList: [],
			collapse: true
		}
	},
	created () {
		this.checkSmallCategory()
		this.getBigCategory()
		this.getCustomer()
		this.initFilters()
	},
	methods: {
		clearSearch () {
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
			this.customerName = ''
			this.customerCode = ''
			this.liquidateflag = '-1'
			this.orderstatus = []
			this.customercategoryid = []
		},
		bcChange (value) {
			this.bigcategoryid = '' + value
			this.smallcategoryid = '0'
			if (this.bigcategoryview === 1) {
				this.getSmalCategory()
			}
		},
		getSmalCategory () {
			let params = {
				pid: this.bigcategoryid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bc = res.data
				}
			})
		},
		// 是否开启小类
		checkSmallCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.bigcategoryview = res.bigcategoryview
			})
		},
		inputEnterHandle () {
			this.$emit('inputEnter')
		},
		getCustomer () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result) {
					this.customList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		initFilters () {
			// debugger
			if (!this.$fxUtils.isEmptyObjSHW(this.$route.query)) {
				let Params = decodeURI(this.$route.query.throughParams)
				let throughParams = this.$fxUtils.JSONparse(Params)
				if (throughParams) {
					this.pname = (throughParams.pName && throughParams.pName.value) || ''
					this.pcode = (throughParams.pCode && throughParams.pCode.value) || ''
					let startDate = throughParams.startDate.value.split(' ')
					let endDate = throughParams.endDate.value.split(' ')
					this.dateValue = [startDate[0] + ` ${startDate[1].substring(0, 5)}`, endDate[0] + ` ${endDate[1].substring(0, 5)}`]
				}
			} else if (!this.$fxUtils.isEmptyObjSHW(this.customSaleNewSearchParams)) {
				const filterMap = {
					ge: 'startDate',
					le: 'endDate',
					cn: 'customerName',
					in: 'customercategoryid'
				}
				const filtersParamsObj = {}
				this.customSaleNewSearchParams.filtersParams.forEach(item => {
					if (filterMap[item.op]) {
						filtersParamsObj[filterMap[item.op]] = item.data
					}
				})
				if (filtersParamsObj) {
					if (filtersParamsObj.startDate && filtersParamsObj.endDate) {
						let startDate = filtersParamsObj.startDate.split(' ')
						let endDate = filtersParamsObj.endDate.split(' ')
						this.dateValue = [startDate[0] + ` ${startDate[1].substring(0, 5)}`, endDate[0] + ` ${endDate[1].substring(0, 5)}`]
					}
					if (filtersParamsObj.customerName) {
						this.customerName = filtersParamsObj.customerName
					}
					if (filtersParamsObj.customercategoryid) {
						this.customercategoryid = filtersParamsObj.customercategoryid.split(',')
					}
				}
			} else {
				this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
			}
		},
		getFiltersDate () {
			return [
				{ name: 'startDate', field: 'createDate', value: `${this.dateValue[0]}:00`, 'op': 'ge', type: 'filtersParams' },
				{ name: 'endDate', field: 'createDate', value: `${this.dateValue[1]}:59`, 'op': 'le', type: 'filtersParams' }
			]
		},
		getFiltersParams () {
			let filtersParams = []
			let cParams = []
			if (this.dateValue === '' ||
				this.dateValue === null ||
				this.dateValue === undefined) {
				filtersParams = [
					{ field: 'createDate', data: ``, 'op': 'ge', name: '时间周期' },
					{ field: 'createDate', data: ``, 'op': 'le', name: '时间周期' }
				]
			} else {
				filtersParams = [
					{ field: 'createDate', data: `${this.dateValue[0]}:00`, 'op': 'ge', name: '时间周期' },
					{ field: 'createDate', data: `${this.dateValue[1]}:59`, 'op': 'le', name: '时间周期' }
				]
			}
			if (this.customerName) {
				let customerNameObj = { 'field': 'customerName', 'data': this.customerName, 'op': 'cn' }
				filtersParams.push(customerNameObj)
			}
			if (this.customercategoryid.length !== 0) {
				let customercategoryid = { 'field': 'customercategoryid', 'data': this.customercategoryid.join(','), 'op': 'in' }
				filtersParams.push(customercategoryid)
			}
			return {
				filtersParams,
				cParams
			}
		},
		handleCollapse () {
			this.collapse = !this.collapse
		}
	}
}
</script>
<style lang="stylus" scoped>
.filters-box {
	width:100%
	display: flex
	.filters-box-row {
		flex: 1
		display:flex
		flex-wrap: wrap
		overflow: hidden
		&>div {
			margin-bottom: 10px
			&>span {
				display: inline-block;
				width: 100px;
				text-align: right
			}
		}
		.order-type-box {
			// margin-right:10px
			.order-type-select {
				width:150px
			}
		}
		.order-NO-box, .order-name-box{
			// margin-right: 10px;
			.order-input {
				width:150px
			}
		}
	}
	.collapse-box {
		width: 80px;
		margin-left: 10px
		flex-shrink: 0
	}
}
</style>
<style lang="stylus">
.filter-time-popper {
	.el-button--text {
		display: none
	}
}
</style>
